import * as ents from '@attain-apps/entities'

/**
 * Type alias for Variable. While it may seem redundant now, it provides
 * flexibility for future enhancements. If we extend the variable Definition
 * later, using a type alias ensures we won’t need to update the type in
 * multiple places.
 */
// TODO: consider creating one shared definition.ts file because we have some
// duplicated code in here and in me/variable-overrides/models/definitions.ts
export type Definition = ents.core.dms.data.query.Variable
export namespace Definition {
  /**
   * List of variable definitions
   */
  export type List = readonly Definition[]

  /**
   * Attempts to cast the default value of a variable definition based on the
   * type.
   *
   * If the type exists in the provided schema, the default value is cast using
   * the schema's type information. Otherwise, the original default value is
   * retained.
   */
  export function castValue(
    definition: Definition,
    dmsSchema: ents.core.dms.models.Schema,
  ): Definition {
    const type = dmsSchema.tryGetType(definition.type)
    return {
      ...definition,
      defaultValue: type
        ? ents.core.common.value.Raw.cast(definition.defaultValue, type)
        : definition.defaultValue,
    }
  }

  /**
   * Try to cast the default value for currently editing definition if type is
   * defined
   */
  export function tryCastValue(
    definition: Partial<Definition>,
    dmsSchema: ents.core.dms.models.Schema,
  ): Partial<Definition> {
    return definition.type
      ? // Safe to cast here: we only use fields required by Definition,
        // and casting enables us to reuse castValue logic for type-based
        // casting.
        { ...castValue(definition as Definition, dmsSchema) }
      : definition
  }
}
